"use strict";

function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && _typeof(from) === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step;
    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return to;
};
var __toESM = function __toESM(mod, isNodeMode, target) {
  return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
    value: mod,
    enumerable: true
  }) : target, mod);
};
var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};

// src/index.ts
var src_exports = {};
__export(src_exports, {
  extendBaseTheme: function extendBaseTheme() {
    return _extendBaseTheme;
  },
  extendTheme: function extendTheme() {
    return _extendTheme;
  },
  mergeThemeOverride: function mergeThemeOverride() {
    return _mergeThemeOverride;
  },
  withDefaultColorScheme: function withDefaultColorScheme() {
    return _withDefaultColorScheme;
  },
  withDefaultProps: function withDefaultProps() {
    return _withDefaultProps;
  },
  withDefaultSize: function withDefaultSize() {
    return _withDefaultSize;
  },
  withDefaultVariant: function withDefaultVariant() {
    return _withDefaultVariant;
  }
});
module.exports = __toCommonJS(src_exports);

// src/extend-theme.ts
var import_theme = require("@chakra-ui/theme");
var import_lodash = __toESM(require("lodash.mergewith"));
function isFunction(value) {
  return typeof value === "function";
}
function pipe() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }
  return function (v) {
    return fns.reduce(function (a, b) {
      return b(a);
    }, v);
  };
}
var createExtendTheme = function createExtendTheme(theme2) {
  return function extendTheme2() {
    for (var _len2 = arguments.length, extensions = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      extensions[_key2] = arguments[_key2];
    }
    var overrides = [].concat(extensions);
    var activeTheme = extensions[extensions.length - 1];
    if ((0, import_theme.isChakraTheme)(activeTheme) &&
    // this ensures backward compatibility
    // previously only `extendTheme(override, activeTheme?)` was allowed
    overrides.length > 1) {
      overrides = overrides.slice(0, overrides.length - 1);
    } else {
      activeTheme = theme2;
    }
    return pipe.apply(void 0, _toConsumableArray(overrides.map(function (extension) {
      return function (prevTheme) {
        return isFunction(extension) ? extension(prevTheme) : _mergeThemeOverride(prevTheme, extension);
      };
    })))(activeTheme);
  };
};
var _extendTheme = createExtendTheme(import_theme.theme);
var _extendBaseTheme = createExtendTheme(import_theme.baseTheme);
function _mergeThemeOverride() {
  for (var _len3 = arguments.length, overrides = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    overrides[_key3] = arguments[_key3];
  }
  return (0, import_lodash["default"]).apply(void 0, [{}].concat(overrides, [mergeThemeCustomizer]));
}
function mergeThemeCustomizer(source, override, key, object) {
  if ((isFunction(source) || isFunction(override)) && Object.prototype.hasOwnProperty.call(object, key)) {
    return function () {
      var sourceValue = isFunction(source) ? source.apply(void 0, arguments) : source;
      var overrideValue = isFunction(override) ? override.apply(void 0, arguments) : override;
      return (0, import_lodash["default"])({}, sourceValue, overrideValue, mergeThemeCustomizer);
    };
  }
  return void 0;
}

// src/theme-extensions/with-default-color-scheme.ts
var import_shared_utils = require("@chakra-ui/shared-utils");
function _withDefaultColorScheme(_ref) {
  var colorScheme = _ref.colorScheme,
    components = _ref.components;
  return function (theme2) {
    var names = Object.keys(theme2.components || {});
    if (Array.isArray(components)) {
      names = components;
    } else if ((0, import_shared_utils.isObject)(components)) {
      names = Object.keys(components);
    }
    return _mergeThemeOverride(theme2, {
      components: Object.fromEntries(names.map(function (componentName) {
        var withColorScheme = {
          defaultProps: {
            colorScheme: colorScheme
          }
        };
        return [componentName, withColorScheme];
      }))
    });
  };
}

// src/theme-extensions/with-default-size.ts
var import_shared_utils2 = require("@chakra-ui/shared-utils");
function _withDefaultSize(_ref2) {
  var size = _ref2.size,
    components = _ref2.components;
  return function (theme2) {
    var names = Object.keys(theme2.components || {});
    if (Array.isArray(components)) {
      names = components;
    } else if ((0, import_shared_utils2.isObject)(components)) {
      names = Object.keys(components);
    }
    return _mergeThemeOverride(theme2, {
      components: Object.fromEntries(names.map(function (componentName) {
        var withSize = {
          defaultProps: {
            size: size
          }
        };
        return [componentName, withSize];
      }))
    });
  };
}

// src/theme-extensions/with-default-variant.ts
var import_shared_utils3 = require("@chakra-ui/shared-utils");
function _withDefaultVariant(_ref3) {
  var variant = _ref3.variant,
    components = _ref3.components;
  return function (theme2) {
    var names = Object.keys(theme2.components || {});
    if (Array.isArray(components)) {
      names = components;
    } else if ((0, import_shared_utils3.isObject)(components)) {
      names = Object.keys(components);
    }
    return _mergeThemeOverride(theme2, {
      components: Object.fromEntries(names.map(function (componentName) {
        var withVariant = {
          defaultProps: {
            variant: variant
          }
        };
        return [componentName, withVariant];
      }))
    });
  };
}

// src/theme-extensions/with-default-props.ts
function pipe2() {
  for (var _len4 = arguments.length, fns = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    fns[_key4] = arguments[_key4];
  }
  return function (v) {
    return fns.reduce(function (a, b) {
      return b(a);
    }, v);
  };
}
function _withDefaultProps(_ref4) {
  var _ref4$defaultProps = _ref4.defaultProps,
    colorScheme = _ref4$defaultProps.colorScheme,
    variant = _ref4$defaultProps.variant,
    size = _ref4$defaultProps.size,
    components = _ref4.components;
  var identity = function identity(t) {
    return t;
  };
  var fns = [colorScheme ? _withDefaultColorScheme({
    colorScheme: colorScheme,
    components: components
  }) : identity, size ? _withDefaultSize({
    size: size,
    components: components
  }) : identity, variant ? _withDefaultVariant({
    variant: variant,
    components: components
  }) : identity];
  return function (theme2) {
    return _mergeThemeOverride(pipe2.apply(void 0, fns)(theme2));
  };
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  extendBaseTheme: _extendBaseTheme,
  extendTheme: _extendTheme,
  mergeThemeOverride: _mergeThemeOverride,
  withDefaultColorScheme: _withDefaultColorScheme,
  withDefaultProps: _withDefaultProps,
  withDefaultSize: _withDefaultSize,
  withDefaultVariant: _withDefaultVariant
});